import { ifProp, theme } from 'styled-tools';

import Arrow from '../icons/Arrow';
import Link from 'next/link';
import React, { forwardRef } from 'react';
import prepInternalUrl from '../../../lib/prepInternalUrl';
import { rem } from 'polished';
import styled from 'styled-components';

const StyledButton = styled.a`
  display: inline-block;
  color: ${theme('colors.white')};
  background-color: ${theme('colors.orange')};
  font-size: ${rem(18)};
  font-weight: 500;
  text-transform: uppercase;
  user-select: none;
  padding: 0.5em 1em 0.5em 1em;
  transition: box-shadow 0.3s;
  :hover {
    color: ${theme('colors.white')};
    box-shadow: 4px 4px 0px 0px var(--cta-hover-shadow, ${theme('colors.darkOrange')});
  }
  :active {
    background-color: ${theme('colors.altOrange')};
  }
`;

const StyledLink = styled.a<{ hoverMode?: string }>`
  --ctaFontColor: ${theme('colors.orange')};
  color: var(--ctaFontColor);
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  svg,
  path {
    stroke: var(--ctaFontColor);
  }

  :hover {
    color: ${ifProp({ hoverMode: 'light' }, theme('colors.white'), theme('colors.blue'))};
    svg,
    path {
      fill: ${ifProp({ hoverMode: 'light' }, theme('colors.white'), theme('colors.blue'))};
      stroke: ${ifProp({ hoverMode: 'light' }, theme('colors.white'), theme('colors.blue'))};
    }
  }
`;

interface CtaProps {
  as?: React.ElementType;
  children: React.ReactNode;
  to?: string;
  type?: string;
  hoverMode?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent) => void;
  id?: string;
}

// a comment

const Cta = forwardRef<HTMLAnchorElement, CtaProps>(({ children, to, type, hoverMode, ...props }, ref) => {
  const url = prepInternalUrl(to);
  if (url.startsWith('/')) {
    return type === 'link' ? (
      <Link href={url} passHref legacyBehavior>
        <StyledLink hoverMode={hoverMode} {...props}>
          {children}
          <Arrow style={{ marginLeft: '15px' }} />
        </StyledLink>
      </Link>
    ) : (
      <StyledButton href={url} {...props}>
        {children}
      </StyledButton>
    );
  }

  return (
    <StyledLink
      // as={OutboundLink}
      ref={ref}
      href={url}
      hoverMode={hoverMode}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
      <Arrow style={{ marginLeft: '15px' }} />
    </StyledLink>
  );
});

export default Cta;
